import { dispatch, useReframe } from 'nike-re-framejs';
import React from 'react';

import { fireGAEvent } from '@/analytics';
import { CheckButton } from '@/common/components/RadioButton';
import i18n from '@i18n';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import { storeNotificationsSettings, subscribeToTicket, unsubscribeFromTicket } from '@/notifications/handlers';
import {
    subscriptionsSettingsPicksTracking$,
    subscriptionsSettingsTicketTracking$,
    ticketSubscriptions$
} from '@/notifications/subs';

const TicketNotifyDialog = ({ ticketId }) =>
    ticketId ? <TicketDetailNotificationsDialog ticketId={ticketId} /> : <TicketEditorNotificationsDialog />;

function TicketDetailNotificationsDialog({ ticketId }) {
    const { subscribe } = useReframe();
    const { ticketTracking, picksTracking } = subscribe(ticketSubscriptions$(ticketId));

    function updateSubscriptions(ticketT, pickT) {
        if (!ticketT && !pickT) {
            dispatch(unsubscribeFromTicket(ticketId));
        } else {
            dispatch(subscribeToTicket(ticketId, ticketT, pickT));
        }
    }
    return (
        <TicketChoicesDialog
            ticketTracking={ticketTracking}
            picksTracking={picksTracking}
            updateSubscriptions={updateSubscriptions}
        />
    );
}

function TicketEditorNotificationsDialog() {
    const { subscribe } = useReframe();
    const ticketTracking = subscribe(subscriptionsSettingsTicketTracking$);
    const picksTracking = subscribe(subscriptionsSettingsPicksTracking$);

    function updateSubscriptions(ticketT, pickT) {
        const ticketTrackingChanged = ticketT !== ticketTracking;
        fireGAEvent(
            'Editor tiketu',
            ticketTrackingChanged ? 'Sledovanie tiketu' : 'Sledovanie zapasov',
            ticketTrackingChanged ? `${ticketT ? 'ON' : 'OFF'}` : `${pickT ? 'ON' : 'OFF'}`
        );
        dispatch(storeNotificationsSettings(ticketT, pickT));
    }
    return (
        <TicketChoicesDialog
            ticketTracking={ticketTracking}
            picksTracking={picksTracking}
            updateSubscriptions={updateSubscriptions}
        />
    );
}

const TicketChoicesDialog = ({ ticketTracking, picksTracking, updateSubscriptions }) => (
    <Docked>
        <DialogTitle>{i18n('notifications.ticket')}</DialogTitle>
        <DialogBody>
            <CheckButton
                active={ticketTracking}
                onClick={() => updateSubscriptions(!ticketTracking, picksTracking)}
                dataAtid="notification-checkbox"
            >
                {i18n('notifications.ticketTracking')}
            </CheckButton>
            <CheckButton
                active={picksTracking}
                onClick={() => updateSubscriptions(ticketTracking, !picksTracking)}
                dataAtid="notification-checkbox"
            >
                {i18n('notifications.pickTracking')}
            </CheckButton>
        </DialogBody>
    </Docked>
);

export default TicketNotifyDialog;
